import {
  ActivityFilterKey,
  useActivityListFilter,
  useSetActivityListFilter,
} from '@gripp/shared-logic';
import { useTranslation } from 'react-i18next';
import { SearchWrapper } from './searchWrapper';

export type ActivitySearchProps = {
  mode: 'page' | 'modal';
  onBack?: () => void;
  onDismiss?: () => void;
  isVisible?: boolean;
  filterKey?: ActivityFilterKey;
};

export function ActivitySearch({
  mode,
  onBack,
  onDismiss,
  isVisible,
  filterKey = ActivityFilterKey.Activity,
}: ActivitySearchProps) {
  const { t } = useTranslation();
  const { data: activityFilter } = useActivityListFilter(filterKey);
  const { mutateAsync } = useSetActivityListFilter(filterKey);

  const updateSearch = async (keyword: string) => {
    if (activityFilter) {
      activityFilter.keyword = keyword;
      await mutateAsync(activityFilter);
    }
  };

  return (
    <SearchWrapper
      mode={mode}
      onBack={onBack}
      isVisible={isVisible}
      onDismiss={onDismiss}
      recentSearchesKey="activity_recent_searches"
      currentKeyword={activityFilter?.keyword}
      onSearchUpdate={updateSearch}
      searchPlaceholder={t('activity.filter.searchPlaceholder')}
      searchButtonKey="activity.search.search"
      recentSearchesTitleKey="activity.search.recentSearches"
    />
  );
}
